module.exports = __webpack_public_path__ + "img/symbol_questionred.8cf5ee3f.png";